export default "__VITE_ASSET__19a005f5__"